/*  ========================================================================
    # Scripts - Page Status
    ========================================================================  */

/**
 * Script that checks the current status of the page
 * and adds the corresponding classes to the html tag.
 */

const Buttons = {
  cfg: {
    lightOrangeButtons: document.querySelectorAll('a.c-button--light-orange')
  },

  /**
   * Add span tag to orange outline buttons to allow background transition
   */
  enhanceButtons() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        for (let i = 0; i < this.cfg.lightOrangeButtons.length; i++) {
          this.cfg.lightOrangeButtons[i].innerHTML = '<span>' + this.cfg.lightOrangeButtons[i].innerHTML + '</span>';
        }
      }
    };
  },

  /**
   * Initialize.
   */
  init() {
    this.enhanceButtons();
  }
};


export default Buttons;
